module.exports = __webpack_public_path__ + "static/media/FemaleFounderUpdated.a8caa080.svg";